<template>
	<div class="compile page-container">
		<div class="page-title">
			藏品信息编辑
		</div>
		<div class="page-content custom-scroll-bar">
			<el-form :model="commodityForm" :rules="rules" ref="commodityForm" label-width="150px" class="ruleForm">
				<el-form-item label="藏品名称" prop="name">
					<el-input v-model="commodityForm.name" type="text" placeholder="请输入藏品名称"></el-input>
				</el-form-item>
				<!-- <div class="upload-video">
					<div class="upload-key">
						<span>*</span>上传视频
					</div>
					<div class="upload-value">
						<el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
							:on-success="handleVideoSuccess" :before-upload="beforeVideoUpload"
							:headers="{Authtoken:token}" accept=".mp4">
							<video v-if="commodityForm.videoUrl!=''" :src="commodityForm.videoUrl" controls
								class="video"></video>
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
				</div> -->
				<div class="upload-image">
					<div class="upload-key">
						<span>*</span>上传图片
					</div>
					<!-- <div class="upload-value">
						<el-upload :action="uploadFileUrl" list-type="picture-card" :on-success="handleImageSuccess"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :multiple="true"
							:headers="{Authtoken:token}" accept="image/*">
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div> -->
					<div class="upload-value">
						<el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
							:on-success="handleImageSuccess" :before-upload="beforeImageUpload"
							:headers="{Authtoken:token}" accept="image/*">
							<img v-if="commodityForm.image_url" :src="$pub.imageUrl+commodityForm.image_url" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
				</div>
				<el-form-item label="创作完成时间" prop="create_time">
					<el-date-picker type="date" placeholder="选择日期" v-model="commodityForm.create_time"
						style="width: 400px;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
						:picker-options="pickerOptions">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="藏品作者(发行方)" prop="author">
					<el-input v-model="commodityForm.author" type="text" placeholder="请输入藏品作者(发行方)"></el-input>
				</el-form-item>
				<el-form-item label="藏品类别" prop="type">
					<el-cascader v-model="commodityForm.type" :options="typeList" :props="props" @change="handleChange"
						placeholder="请选择藏品类别" style="width: 400px;"></el-cascader>
				</el-form-item>
				<el-form-item label="藏品标签" prop="tags">
					<el-select v-model="commodityForm.tags" multiple filterable allow-create default-first-option
						placeholder="请选择藏品标签">
						<el-option v-for="item in tags" :key="item.id" :label="item.labelName" :value="item.labelName">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="rich-text">
					<div class="key">
						<span>*</span>藏品介绍：
					</div>
					<div class="value">
						<Tinymce v-model="commodityForm.introduce" placeholder="请编辑您的藏品介绍..." :height="500"></Tinymce>
					</div>
				</div>
				<el-form-item label="上链渠道" prop="channel">
					<el-select v-model="commodityForm.channel" placeholder="上链渠道">
						<el-option v-for="(item,index) in channelList" :key="index" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<div class="login-button">
					<el-button type="primary" :loading="loading" @click="saveCommodityInfo">保存商品信息</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Tinymce from '@/components/Tinymce'
	export default {
		name: 'compile',
		components: {
			Tinymce
		},
		data() {
			return {
				commodityForm: {
					name: '',
					videoUrl: '',
					// image_list: [],
					image_url: '',
					channel: '',
					create_time: '',
					author: '',
					type: [],
					tags: [],
					introduce: ''
				},
				channelList: [{
						label: '百度',
						value: 1
					},
					{
						label: '中经天平',
						value: 2
					}
				],
				typeList: [],
				props: {
					label: 'typeName',
					value: 'lotTypeId',
					children: 'childrens'
				},
				tags: [],
				rules: {
					name: [{
						required: true,
						trigger: 'blur',
						message: '请输入藏品名称'
					}],
					create_time: [{
						required: true,
						trigger: 'change',
						message: '请选择作品创作完成时间'
					}],
					author: [{
						required: true,
						trigger: 'blur',
						message: '请输入藏品作者(发行方)'
					}],
					type: [{
						required: true,
						trigger: 'change',
						message: '请选择藏品类别'
					}],
					tags: [{
						required: true,
						trigger: 'change',
						message: '请选择藏品标签'
					}],
					channel: [{
						required: true,
						trigger: 'change',
						message: '请选择上链渠道'
					}]
				},
				uploadFileUrl: '',
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				loading: false,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e7就是不可以选择今天的 
					}

				}
			};
		},
		methods: {
			// 上传视频成功
			handleVideoSuccess(res, file) {
				if (res.code == 200) {
					this.commodityForm.videoUrl = res.data.fileUrl
				}
			},
			// 上传视频前
			beforeVideoUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 300;
				if (!isLt2M) {
					this.$message.error('上传视频大小不能超过 300MB!');
				}
				return isLt2M;
			},
			// 图片列表移除
			handleRemove(file, fileList) {
				this.disposeFileList(fileList)
			},
			// 图片列表预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 上传图片成功
			// handleImageSuccess(res, file, fileList) {
			// 	if (res.code == 200) {
			// 		this.disposeFileList(fileList)
			// 	}
			// },
			handleImageSuccess(res, file) {
				console.log(file);
				if (res.code == 200) {
					this.commodityForm.image_url = res.data.fileUrl
					this.commodityForm.fileSize = file.size
					// this.disposeFileList(file)
				}
			},
			disposeFileList(fileList) {
				let array = new Array()
				for (var i = 0; i < fileList.length; i++) {
					if (fileList[i].response.data) {
						array.push(fileList[i].response.data.fileUrl)
					}
				}
				this.commodityForm.image_list = array
			},
			// 上传图片前
			beforeImageUpload(file) {
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('上传藏品大小不能超过 5MB!');
				}
				return isLt5M;
			},
			saveCommodityInfo() {
				this.$refs.commodityForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$api.commodityAdd({
							lotName: this.commodityForm.name,
							videoUrl: this.commodityForm.videoUrl,
							// lotPictrueUrl: this.commodityForm.image_list.join(','),
							lotPictrueUrl: this.commodityForm.image_url,
							lotPictrueSize: this.commodityForm.fileSize,
							finishTime: this.commodityForm.create_time + ' 00:00:00',
							lotAuthor: this.commodityForm.author,
							lotOneType: this.commodityForm.type[0],
							lotTwoType: this.commodityForm.type[1],
							lotLabel: this.commodityForm.tags.join(','),
							lotDescribe: this.commodityForm.introduce,
							// describe: '藏品简介藏品简介藏品简介藏品简介藏品简介藏品简介藏品简介',
							cochainChannel: this.commodityForm.channel
						}, res => {
							this.loading = false
							if (res.code == 200) {
								this.$message({
									type: 'success',
									duration: 2000,
									message: '藏品上链成功！',
									onClose: () => {
										this.$router.back()
									}
								})
							}
						})
					}
				})
			},
			handleChange() {

			},
			fetchClassify() {
				this.$api.classifyAll({}, res => {
					if (res.code == 200) {
						this.typeList = res.data
					}
				})
			},
			fetchTags() {
				this.$api.tagsAll({}, res => {
					if (res.code == 200) {
						this.tags = res.data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.uploadFileUrl = this.$pub.requestUrl + 'uploadImg'
			this.token = this.$pub.getStorage('adm_token')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchClassify()
			this.fetchTags()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.compile {
		overflow: hidden;
	}

	.page-title {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-sm;
		box-sizing: border-box;
		background: @vue-bg-color-grey;
	}

	.page-content {
		width: 100%;
		height: calc(100% - 50px);
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
		overflow: auto;
	}

	.upload-video,
	.upload-image,
	.upload-datum,
	.rich-text {
		display: flex;
		margin-bottom: @vue-spacing-col-lg;
	}

	.upload-key,
	.key {
		width: 150px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: @vue-spacing-row-sm + 4;
		box-sizing: border-box;
		font-size: @vue-font-size-sm - 2;
		color: @vue-text-color;

		span {
			color: @vue-text-color-red;
		}
	}

	.upload-value,
	.value {
		width: calc(100% - 450px);
	}

	.el-input,
	.el-select,
	.el-date-editor {
		width: 400px;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		box-sizing: border-box;
		border-radius: @vue-border-radius-base;
		background: #fbfdff;
	}

	.avatar-uploader-icon:hover {
		border-color: #409EFF;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.video {
		width: 148px;
		height: 148px;
		display: block;
	}

	.login-button {
		padding-left: 150px;
		box-sizing: border-box;
		margin-bottom: @vue-spacing-col-lg*2;

		.el-button {
			width: 200px;
		}
	}
</style>
